import {
  IconWrapper,
  SectionContainer,
  StepCard,
  StepDescription,
  StepsContainer,
  StepTitle,
} from "./styled.components";
import { Title } from "../Title/Title";

import { Message, MessageSections } from "../../../components/message/message";

import globus from "../../../../assets/icons/globus.png";
import idCard from "../../../../assets/icons/id-card.png";
import shoppingCart from "../../../../assets/icons/shopping-cart.png";

const HowItWorks: React.FC = () => {
  
  const steps = [
    {
      icon: idCard,
      title: "how_it_works_register",
      description: "how_it_works_register_desc",
    },
    {
      icon: globus,
      title: "how_it_works_addresses",
      description: "how_it_works_addresses_desc",
    },
    {
      icon: shoppingCart,
      title: "how_it_works_orders",
      description: "how_it_works_orders_desc",
    },
  ];

  return (
    <SectionContainer>
      <Title variant="h2">
        <Message
          messageKey={"how_it_works_section_title"}
          sectionId={MessageSections.MAIN}
        />
      </Title>
      <StepsContainer>
        {steps.map((step, index) => (
          <StepCard key={index}>
            <IconWrapper>
              <img src={step.icon} alt={step.title} />
            </IconWrapper>
            <StepTitle variant="h5">
              <Message
                messageKey={step.title}
                sectionId={MessageSections.MAIN}
              />
            </StepTitle>
            <StepDescription>
              <Message
                messageKey={step.description}
                sectionId={MessageSections.MAIN}
              />
            </StepDescription>
          </StepCard>
        ))}
      </StepsContainer>
    </SectionContainer>
  );
};

export default HowItWorks;
